import {useEffect,useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {supabase} from '../../lib/supabase/client';
import {subscribeToNativeAuth} from '../../lib/auth/nativeAuth';

export default function NativeAuthBridge() {
  const navigate = useNavigate();
  const navigateRef = useRef(navigate);

  useEffect(() => {
    navigateRef.current = navigate;
  }, [navigate]);

  useEffect(() => {
    let disposed = false;
    let unsubscribe = () => {};

    subscribeToNativeAuth({
      client: supabase,
      onComplete: (returnTo) => {
        if (!disposed) navigateRef.current(returnTo || '/login', {replace: true});
      },
      onError: () => {
        if (!disposed) navigateRef.current('/login?error=native_auth_failed', {replace: true});
      }
    }).then((remove) => {
      if (disposed) remove();
      else unsubscribe = remove;
    }).catch(() => {
      if (!disposed) navigateRef.current('/login?error=native_auth_failed', {replace: true});
    });

    return () => {
      disposed = true;
      unsubscribe();
    };
  }, []);

  return null;
}
